import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { OverridablePropertiesPermissions } from '@/common/constants';
import { API_URL } from '@/dtos';

const useGetOverridablePropertiesPermissions = (enabled: boolean, userId?: string) => {
  const { data, isLoading, isSuccess } = useQuery(
    [API_URL.ORGANIZATION_PROPERTIES_STATES, userId],
    () => (userId ? api.get(API_URL.ORGANIZATION_PROPERTIES_STATES) : null),
    { enabled }
  );
  const properties = useMemo(() => {
    const result: OverridablePropertiesPermissions = {
      ...data?.data?.overridable_properties,
      ...data?.data?.properties,
    };
    return result;
  }, [data?.data?.overridable_properties, data?.data?.properties]);

  return {
    overridablePropertiesPermissions: data?.data?.overridable_properties || null,
    properties,
    isLoading,
    isSuccess,
  };
};

export default useGetOverridablePropertiesPermissions;
